// AUTO-GENERATED by scripts/generate-build-info.js — do not edit.
export const BUILD_INFO = {
  version: "1.0.0",
  gitSha: "21a7acfb",
  buildDate: "2026-11-04"
} as const;
